import { api } from "@/api/client";
import type {
  MpCreateRequest,
  MpCreateResponse,
  MpPreviewResponse,
  MpReportListItem,
  MpUploadResponse,
} from "@/types/api";

export async function listMpReports(): Promise<MpReportListItem[]> {
  const { data } = await api.get<MpReportListItem[]>("/marketplace-reports");
  return data;
}

export async function uploadMpReport(args: {
  file: File;
  mp_code: string;
  organization_key: string;
  organization_name: string;
  // Второй файл — обязателен для Ozon (B2B-реестр продаж).
  aux_file?: File | null;
}): Promise<MpUploadResponse> {
  const form = new FormData();
  form.append("file", args.file);
  if (args.aux_file) {
    form.append("aux_file", args.aux_file);
  }
  form.append("mp_code", args.mp_code);
  form.append("organization_key", args.organization_key);
  form.append("organization_name", args.organization_name);
  // Не форсируем Content-Type — axios сам поставит multipart с boundary.
  const { data } = await api.post<MpUploadResponse>(
    "/marketplace-reports/upload",
    form,
  );
  return data;
}

export async function getMpReportPreview(
  id: string,
): Promise<MpPreviewResponse> {
  const { data } = await api.get<MpPreviewResponse>(
    `/marketplace-reports/${id}/preview`,
  );
  return data;
}

export async function createMpReportInUnf(
  id: string,
  body: MpCreateRequest,
): Promise<MpCreateResponse> {
  const { data } = await api.post<MpCreateResponse>(
    `/marketplace-reports/${id}/create-in-1c`,
    body,
  );
  return data;
}

export async function updateMpReportInUnf(
  id: string,
  kind: string,
  body: MpCreateRequest,
): Promise<MpCreateResponse> {
  const { data } = await api.post<MpCreateResponse>(
    `/marketplace-reports/${id}/update-in-1c/${kind}`,
    body,
  );
  return data;
}

export async function deleteMpReport(id: string): Promise<void> {
  await api.delete(`/marketplace-reports/${id}`);
}
